export default function(type) {
  return [{
    "name": "管理",
    "icon": "el-icon-setting",
    "children": [{
      "title": "管理设置",
      "children": [],
      "paths": [
        "/comprehensive-setting", //基本设置
        "/role", //员工管理表
        "/organization", //组织架构
        "/comprehensive-unusual", //异常通知
        "/comprehensive-question", //需求反馈
        "/adminlog", //操作日志
        "/bank-account", //财务收支账户
        "/device-list", //硬件管理
        "/marketing-applets", //第三方配置
      ]
    }, {
      "title": "商品管理",
      "children": [],
      "paths": [
        "/comprehensive-goodstype", //商品分类
        "/comprehensive-goods", //商品列表
        "/cloud-goods", //云商品库
        "/parent-goods", //集采商品库
        "/traceability", //产地溯源
        "/residues", //商品检测
        "/process-management", //加工工艺管理
        "/cookbooks", //营养菜谱
      ]
    }, {
      "title": "客户管理",
      "children": [],
      "paths": [
        "/comprehensive-customer", //客户列表
        "/business-visit", //客户拜访
        "/business-collection", //发起收款
        "/commission", //提成方案
        "/commission-proxy", //代采收费
        "/feeSetting", //配送运费
      ]
    }, {
      "title": "供应商管理",
      "children": [],
      "paths": [
        "/procurement-supplier", //供应商家
      ]
    }, {
      "title": "品牌商",
      "children": [],
      "paths": [
        "/brand-welcome", //欢迎页
        "/brand-staffMember", //工作人员
        "/brand-businessStatistics", //业务统计
        "/brand-goodsStatistics", //商品统计
        "/brand-purchaseStatistics", //采购统计
        "/brand-commodityProfit", //商品利润
        "/brand-orderProfit", //订单利润
        "/brand-financialCollection", //财务收款
      ]
    }]
  }, {
    "name": "订单",
    "icon": "el-icon-document",
    "children": [{
      "title": "订单管理",
      "children": [],
      "paths": [
        "/comprehensive-order", //订单列表
        "/help-order", //代客下单
        "/order-goods", //订单商品
        "/goods-summary", //商品汇总
        "/returnOrder", //退货订单
        "/order-print", //订单打印设置
        "/after-sale", //商品售后处理
        "/aftersale-print", //售后单选项
        "/warehouse-change", //销售退货 未添加数据
        "/checkindata?type=4&status=in", //退货入库单表
      ]
    }, {
      "title": "寄售铺货",
      "children": [],
      "paths": [
        "/consignment-sales", //寄售销售表
        "/consignment-goods", //寄售商品库
        "/consignment-settlement", //寄售结算列表
      ]
    }]
  }, {
    "name": "采购",
    "icon": "el-icon-shopping-cart-1",
    "children": [{
      "title": "采购设置",
      "children": [],
      "paths": [
        "/pricing", //商品定价
        "/enquiry", //线上询价
        "/pricing-audit", //定价审核
        "/pricing-contractual", //客户报价
        "/procurement-audit", //采购超价审核
        "/cate-discount", //分类折扣
        "/designated-supplier", //指定供货
      ]
    }, {
      "title": "任务主线",
      "children": [],
      "paths": [
        "/procurement-task", //采购任务
        "/supplytask", //供货任务
        "/formulate-purchase", //制定采购
        "/replenishment", //预采补采任务
        "/order-list", //采购/供应清单
        "/finance", //采购报账申请
        "/reimbursement-supply", //供应报账申请
        "/statements", //采购供货对账单
        "/parent-task", //集采任务
        "/parent-bill", //集采报单
        "/sales-bill", //销售扣点报账
      ]
    }]
  }, {
    "name": "库房",
    "icon": "el-icon-house",
    "children": [{
      "title": "库房设置",
      "children": [],
      "paths": [
        "/storelist", //库房信息
        "/turnover-basket", //周转筐管理
        "/basket-management", //周转筐v2
      ]
    }, {
      "title": "库存帐表",
      "children": [],
      "paths": [
        "/inventory", //库存商品
        "/checkout-table", //出库送货单
        "/goods-batch", //入库批次记录
        "/checkresult", //盘点记录
        "/checklogs", //出入库日志
      ]
    }, {
      "title": "出入库操作",
      "children": [],
      "paths": [
        // "/checkin", //采购入库
        // "/checkout", //采购退货
        "/takedelivery", //收货入库
        "/audit", //商品入库审核
        "/checkindata?type=1&status=in", //入库单据表
        "/checkindata?type=2&status=out", //采购退货表
        "/inventorysave", //盘点
        "/warehouse-receipt-print", //入库单据打印设置
        "/inventory-conversion-list", //库存转换
      ]
    }]
  }, {
    "name": "分拣",
    "icon": "el-icon-box",
    "children": [{
      "title": "分拣管理",
      "children": [],
      "paths": [
        "/subcontract", //分包任务
        "/sortingtask", //分拣任务
        "/sorting-out", //分拣缺货
        "/processing-task", //加工任务列表
        "/codelist", //标签码记录
        "/goods-barcode", //商品条码库
        "/setting-label", //标签模板
      ]
    }]
  }, {
    "name": "配送",
    "icon": "el-icon-truck",
    "children": [{
      "title": "配送管理",
      "children": [],
      "paths": [
        "/deliverytask", //送货任务
        "/checkout-table", //出库送货单
        "/transport", //商品装车单
        "/deliverymap", //配送排单
        "/cityroute", //线路管理
        "/dspointlist", //团长代收点
        "/address", //客户地图
        "/address2", //送货路径
        "/printsetting", //送货单选项
        "/basket", //篮筐商品
        "/updatedelivery", //修改补录送货单
        "/deliveryback", //取件回库任务
        "/receiving", //直送任务
        "/device-map", //车载监控
      ]
    }]
  }, {
    "name": "财务",
    "icon": "el-icon-coin",
    "children": [{
      "title": "应收项目",
      "children": [],
      "paths": [
        "/periodic-bill", //客户周期结算
        "/initiate", //应收订单表
        "/receivable", //应收对账表
        "/bill-list?status=2", //应收出库报账表
        "/consignment-statements", //应收寄售报账表
        "/basket-bill", //周转筐报账表
      ]
    }, {
      "title": "应付项目",
      "children": [],
      "paths": [
        "/periodic-bill-supplier", //供应商周期结算
        "/statements", //应付采购表
        "/supply-settlement", //应付供应表
        "/sales-settlement", //供应扣点结算
        "/bill-list?status=1", //应付入库报账表
        "/bill-list?status=3", //应付退货入库报账表
        "/bill-list?status=4", //应付供应商报表
        "/apply-withdraw", //团长提现表
        "/plat-withdraw", //账户提现
      ]
    }, {
      "title": "流水记录",
      "children": [],
      "paths": [
        "/running", //财务流水表
        "/integral-flow", //积分流水表
        "/invoice", //开发票申请表
        "/finance-commission", //业务提表成
        "/inout-bill", //收支单据
        "/inout-cate", //类目维护
        "/inoutStatustics", //收支报表
        "/inoutStatustics-account", //账户报表
      ]
    }]
  }, {
    "name": "商城",
    "icon": "el-icon-menu",
    "children": [{
      "title": "营销管理",
      "children": [],
      "paths": [
        "/special-prices", //特价活动
        "/coupon", //优惠券
        "/marketing-promotion", //主题活动二
        "/marketing-supplier", //供应商店推荐
        "/comprehensive-promotion", //主题活动
        "/sales-promotion", //满减/积分
        "/marketing-vip", //付费会员制
        "/recharge", // 充值赠送
      ]
    }, {
      "title": "商城配置",
      "children": [],
      "paths": [
        "/marketing-settingIndex", //自定义首页
        "/setting-shop", //自定义商城
        "/comprehensive-help", //使用帮助
        "/comprehensive-agreement", //项目协议
        "/comprehensive-adverpic", //广告图
        "/comprehensive-notice", //公告头条
        "/plat-locale", //商城端多语言
      ]
    }]
  }, {
    "name": "统计",
    "icon": "el-icon-data-line",
    "children": [{
      "title": "统计报表",
      "children": [],
      "paths": [
        "/todayStatis", //今日经营
        "/dataAnalysis", //客情分析
        "/everydaycount", //每日经营概况
        "/visit", //客户拜访
        "/businessStatistics", //业务统计
        "/statistics-loss", //损耗统计
        "/goodsStatistics2", //商品销售
        "/purchaseStatistics", //采购统计
        "/productStatistics", //分拣成品统计
        "/processingStatistics", //加工包装统计
        "/goodsstatistics", //出入库商品
        "/commodity-circulation", //商品流通
        "/goodsprofit", //下单商品统计
        "/orderstatistics", //订单利润统计
        "/goodsoldstatistics", //分割商品利润
        "/manager-performance", //人员绩效
        "/paymentStatistics", //收款统计
        "/goodsSaleStatistics", //商品售价趋势
        "/gross-margin", //销售毛利表
        "/payStatistics", //付款统计
        "/consignment-profit", //寄售商品利润
        "/afterSaleStatistics", //售后统计
        "/replenishmentStatistics", //补货统计
        "/goods-record", //商品浏览统计
      ]
    }]
  }]
}



// WEBPACK FOOTER //
// ./src/components/layout/Sidebar/sidebar-layout.js